import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/circleOfConfusion.fragment.js
var name, shader, circleOfConfusionPixelShader;
var init_circleOfConfusion_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/circleOfConfusion.fragment.js"() {
    init_shaderStore();
    name = "circleOfConfusionPixelShader";
    shader = `uniform sampler2D depthSampler;varying vec2 vUV;uniform vec2 cameraMinMaxZ;uniform float focusDistance;uniform float cocPrecalculation;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float depth=texture2D(depthSampler,vUV).r;
#define CUSTOM_COC_DEPTH
float pixelDistance=(cameraMinMaxZ.x+cameraMinMaxZ.y*depth)*1000.0; 
#define CUSTOM_COC_PIXELDISTANCE
float coc=abs(cocPrecalculation*((focusDistance-pixelDistance)/pixelDistance));coc=clamp(coc,0.0,1.0);gl_FragColor=vec4(coc,coc,coc,1.0);}
`;
    ShaderStore.ShadersStore[name] = shader;
    circleOfConfusionPixelShader = { name, shader };
  }
});

export {
  circleOfConfusionPixelShader,
  init_circleOfConfusion_fragment
};
